import { ChainId } from '@cronos-app/sdk';
import { Token } from '@ui/models/token/model';

import type { TokenFetcher } from '../model';
import { cdcFetcher } from './cdc';

export const vethFetcher: TokenFetcher<Token.vETH> = {
  support: (token): token is Token.vETH => token === Token.vETH,
  fetch: async (_, layer, desiredNetwork = ChainId.ETHEREUM) => {
    // FIXME: it may not equal ETH in the future
    return cdcFetcher.fetch(Token.ETH, layer, desiredNetwork);
  },
};
